import React from 'react';
import ActivityRow from './ActivityRow';

const ActivityGroup = ({ label, items, currentUser }) => (
  <section className="activity-group">
    <div className="activity-group-label">{label}</div>
    {items.map(item => (
      <ActivityRow key={item._id} item={item} currentUser={currentUser} />
    ))}
  </section>
);

export default ActivityGroup;
